import type { UploadedFile } from '../Data/uploadedFiles';

export function latestUploadDate(files: UploadedFile[]): string | null {
  let latest: string | null = null;
  for (const file of files) {
    if (!file.uploadedAt) continue;
    const time = new Date(file.uploadedAt).getTime();
    if (Number.isNaN(time)) continue;
    if (latest === null || time > new Date(latest).getTime()) {
      latest = file.uploadedAt;
    }
  }
  return latest;
}

export function formatLastUpdated(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const month = date.toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' });
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${month} ${day}, ${date.getUTCFullYear()}`;
}

export function formatUploadDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const month = date.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
  return `${month} ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
}

export function rolledOver(iso: string, today: Date): boolean {
  const uploaded = new Date(iso);
  if (Number.isNaN(uploaded.getTime())) return false;
  const year = today.getUTCMonth() >= 6 ? today.getUTCFullYear() : today.getUTCFullYear() - 1;
  return uploaded.getTime() < Date.UTC(year, 6, 1);
}
